import {
  capitalizeFirstLetter,
  notifyError,
  notifySuccess,
} from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

export const allBids = (id) => async (dispatch) => {
  dispatch({ type: "GETTING_BIDS" });
  try {
    const { data } = await auction.get(`/auction/read/all-bids/${id}`);
    dispatch({ type: "BIDS_DETAILS", payload: data });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "GETTED_BIDS" });
  }
};

export const raisePickup =
  (pickDetails, setIsModalOpen, setKeyValue, setPickupDetails) =>
  async (dispatch) => {
    dispatch({ type: "GETTING_RAISE_PICKUP" });
    try {
      await auction.post(`/pickup/create`, pickDetails).then((res) => {
        setIsModalOpen(false);
        setKeyValue(Math.floor(Math.random() * 100));
        setPickupDetails({
          auction: "",
          offer: "",
          industry: "",
          buyer: "",
          scrapDetails: {
            type: "",
            name: "",
            quantity: "",
            unit: "",
          },
          loadingAssistance: true,
          pickupLocation: {
            latitude: "",
            longitude: "",
            address: "",
            city: "",
            state: "",
            country: "",
            district: "",
          },
          pickupDate: {
            type: "",
            deadLine: "",
            specificDates: [],
          },
          pickupTime: {
            type: "",
            startingTime: "",
            timeRange: {
              startTime: "",
              endTime: "",
            },
          },
        });
        notifySuccess("Raise Pickup Successful!");
        dispatch({ type: "RAISE_PICKUP_REQUEST", payload: res.data });
      });
    } catch (error) {
      notifyError(
        capitalizeFirstLetter(
          error.response ? error.response?.data : error.message
        )
      );
      dispatch({ type: "GETTED_RAISE_PICKUP" });
    }
  };

export const allPickupDetails =
  (currentPage, totalNumberRow, accountType) => async (dispatch) => {
    const skip = (currentPage - 1) * totalNumberRow;
    const userType = (type) => {
      if (type === "industry") {
        return `/pickup/read/read-created-pickups?skip=${skip}&limit=${totalNumberRow}`;
      } else {
        return `/pickup/read/read-received-pickups?skip=${skip}&limit=${totalNumberRow}`;
      }
    };

    dispatch({ type: "GETTING_ALL_PICKUP" });
    try {
      await auction.get(userType(accountType)).then((res) => {
        dispatch({ type: "ALL_PICKUP_DETAILS", payload: res.data });
      });
    } catch (error) {
       notifyError(error.response ? error.response?.data : error.message,error.response?.status);
      dispatch({ type: "GETTED_ALL_PICKUP" });
    }
  };

export const cancelPickupRequest = (id) => async (dispatch) => {
  dispatch({ type: "GETTING_CANCEL_PICKUP" });
  try {
    await auction.put(`/pickup/update/cancel/${id}`).then((res) => {
      notifySuccess("Pickup cancelled successfully");
      dispatch({ type: "CANCEL_PICKUP_REQUEST", payload: res.data });
    });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "GETTED_CANCEL_PICKUP" });
  }
};

export const rejectPickupRequest = (id) => async (dispatch) => {
  dispatch({ type: "GETTING_REJECT_PICKUP" });
  try {
    await auction.put(`/pickup/update/reject/${id}`).then((res) => {
      notifySuccess("Pickup Reject Pickup successfully");
      dispatch({ type: "REJECT_PICKUP_REQUEST", payload: res.data });
    });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "GETTED_REJECT_PICKUP" });
  }
};

export const completdPickupRequest = (id) => async (dispatch) => {
  dispatch({ type: "GETTING_COMPLETED_PICKUP" });
  try {
    await auction.put(`/pickup/update/complete/${id}`).then((res) => {
      notifySuccess("Pickup Completed successfully");
      dispatch({ type: "COMPLETED_PICKUP_REQUEST", payload: res.data });
    });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "ERROR_COMPLETED_PICKUP" });
  }
};

export const acceptPickupRequest = (id) => async (dispatch) => {
  dispatch({ type: "GETTING_ACCEPT_PICKUP" });
  try {
    await auction.put(`/pickup/update/accept//${id}`).then((res) => {
      notifySuccess("Pickup accept successfully");
      dispatch({ type: "ACCEPT_PICKUP_REQUEST", payload: res.data });
    });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "GETTED_ACCEPT_PICKUP" });
  }
};
